@let hasShiftUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);
@let hasServiceUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Service);
@let hasWilsonShareUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.WilsonShare);
@let hasUpdatePermission =
  hasServiceActivity && hasWilsonShareActivity
    ? hasShiftUpdatePermission &&
      hasServiceUpdatePermission &&
      hasWilsonShareUpdatePermission
    : hasServiceActivity
      ? hasShiftUpdatePermission && hasServiceUpdatePermission
      : hasWilsonShareActivity
        ? hasShiftUpdatePermission && hasWilsonShareUpdatePermission
        : hasShiftUpdatePermission;

@if ('portal-move-multi-select-shifts' | featureFlagPure | async) {
  <button
    nz-button
    nzType="default"
    class="w-100 fw-normal"
    (click)="moveShiftOperationTriggered.emit()"
    [disabled]="
      !hasUpdatePermission ||
      !(selectedShifts | canAllShiftBeModified) ||
      isOperationOnGoing
    "
    nz-tooltip
    [nzTooltipTitle]="
      !hasUpdatePermission ? ('general.forbidden_action' | translate) : ''
    "
  >
    {{ 'shift.page.move_shifts_header' | translate }}
  </button>
}
